import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { environment } from '@environments/environment';
import { DialogService } from '@service/dialog.service';
import { LoadingService } from '@service/loading.service';
import { RestService } from '@service/rest/rest.service';
import { finalize } from 'rxjs';

export type AllowedProfileTypes = 'OTHER' | 'CARPENTER_PLUS';
export type DialogInput = {
    type: AllowedProfileTypes,
};

@Component({
    selector: 'app-company-profile-inquiry-dialog',
    templateUrl: './company-profile-inquiry-dialog.component.html',
    styleUrls: ['./company-profile-inquiry-dialog.component.scss'],
})
export class CompanyProfileInquiryDialogComponent {

    private type: AllowedProfileTypes;

    public environment = environment;
    public form_group: FormGroup;

    public was_submitted = false;

    constructor(
        private rest_service: RestService,
        private loading_service: LoadingService,
        private dialog_ref: MatDialogRef<CompanyProfileInquiryDialogComponent>,
        private dialog_service: DialogService,
        form_builder: FormBuilder,
        @Inject(MAT_DIALOG_DATA) data: DialogInput,
    ) {
        this.type = data.type;

        this.form_group = form_builder.group({
            company: ['', [Validators.required]],
            location: ['', [Validators.required]],
            name: ['', [Validators.required]],
            position: ['', [Validators.required]],
            email: ['', [Validators.required, Validators.email]],
            phone: ['', [Validators.required]],
            consent: [false, [Validators.requiredTrue]],
        });
    }

    close() {
        this.dialog_ref.close();
    }

    submit() {
        this.was_submitted = true;

        if (this.form_group.invalid) {
            return;
        }

        const values = this.form_group.value;

        this.loading_service.startLoad();

        this.rest_service.postWithSubscription('company-profile-inquiry', {
            type: this.type,
            company: values.company,
            location: values.location,
            name: values.name,
            position: values.position,
            email: values.email,
            phone: values.phone,
        }).pipe(
            // This is called when the request completes or throws an error.
            finalize(() => this.loading_service.stopLoad()),
        ).subscribe(() => {
            // Close this dialog itself and present a simple notification
            // telling the user that their inquiry was received.
            this.dialog_ref.close();
            this.dialog_service.informDialog('Deine Anfrage wurde abgeschickt. Wir melden uns bei dir!');
        });
    }

}
